import { t } from '@web-solutions/module-localization';
import styles from '../../styles/style.module.scss';
import getLocale from 'src/localization/get-locale';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { PhoneIcon } from 'src/onboarding/assets/icons/PhoneIcon';
import { MicrophoneIcon } from 'src/onboarding/assets/icons/MicrophoneIcon';
import { MessageIcon } from 'src/onboarding/assets/icons/MessageIcon';
import { PersonWaveIcon } from 'src/onboarding/assets/icons/PersonWaveIcon';
import { VolumeIcon } from 'src/onboarding/assets/icons/VolumeIcon';
import { LinkIcon } from 'src/onboarding/assets/icons/LinkIcon';

const ICONS = [
  <PhoneIcon />,
  <MicrophoneIcon />,
  <MessageIcon />,
  <PersonWaveIcon />,
  <VolumeIcon />,
  <LinkIcon />,
];

export const FeaturesComponent = () => {
  const { features } = useRemoteConfig();
  const locale = getLocale();

  return (
    <div className={styles.featuresContainer}>
      <div className={styles.featuresHeader}>
        <Typography variant='h3-bold' className={styles.featuresTitle}>
          {t('onboarding.voeryPersonalPlan.features.title').toUpperCase()}
        </Typography>

        <Typography variant='h1-bold'>{features.title[locale]}</Typography>
        <Typography variant='callout-medium' className={styles.featuresSubtitle}>{features.subTitle[locale]}</Typography>
      </div>

      <div className={styles.featuresGrid}>
        {features.options.map((feature, index) => (
          <div key={index} className={styles.featureCard}>
            <div className={styles.featureIcon}>
              {ICONS[index] || <PhoneIcon />}
            </div>
            <div className={styles.featureContent}>
              <Typography variant='body-bold' className={styles.featureTitle}>
                {feature.title[locale]}
              </Typography>
              <Typography variant='callout-medium' className={styles.featureDescription}>
                {feature.subTitle[locale]}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
